module.exports = __webpack_public_path__ + "img/14.da5f01e0.jpg";